<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 0C4.928 0 0 4.928 0 11C0 17.072 4.928 22 11 22C17.072 22 22 17.072 22 11C22 4.928 17.072 0 11 0ZM11 3.3C12.826 3.3 14.3 4.774 14.3 6.6C14.3 8.426 12.826 9.9 11 9.9C9.174 9.9 7.7 8.426 7.7 6.6C7.7 4.774 9.174 3.3 11 3.3ZM11 18.92C8.25 18.92 5.819 17.512 4.4 15.378C4.433 13.189 8.8 11.99 11 11.99C13.189 11.99 17.567 13.189 17.6 15.378C16.181 17.512 13.75 18.92 11 18.92Z"
      fill="#959595"/>
  </svg>
</template>

<script>
export default {
  name: "UserIcon"
}
</script>

<style scoped>

</style>
